<template>
  <div class="page-wrapper bg">
    <div class="title">
      <div>{{ $t('navigation.contactUs2') }}<span v-if="language !== 'en-US'">CONTACT US</span></div>
    </div>
    <div class="content">
      <div class="contact-info" v-for="(item, index) in contactList" :key="index">
        <img :src="item.icon" alt="" class="icon" />
        <div class="label">{{ item.label }}</div>
        <div class="line"></div>
        <div class="value">{{ item.value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contactList: [
        {
          icon: require('@images/mobile/contact/address.png'),
          label: this.$t('addressName'),
          value: this.$t('address')
        },
        {
          icon: require('@images/mobile/contact/phone.png'),
          label: this.$t('contactNumber'),
          value: '0591-87279000'
        },
        {
          icon: require('@images/mobile/contact/email.png'),
          label: this.$t('contactEmail'),
          value: 'chinaegg@vip.sina.com'
        }
      ],
      language: localStorage.getItem('Language')
    }
  },

  components: {},

  computed: {},

  created() {},

  mounted() {},

  methods: {}
}
</script>
<style scoped lang='scss'>
@import '../style.scss';
.bg {
  position: relative;
  background: url('~@images/mobile/contact/bg.jpg') no-repeat;
  background-size: 100% 30.2687vh;
}
.content {
  position: absolute;
  margin: 0 8vw;
  width: 83.4667vw;
  box-shadow: 1px 1px 2.3333vw 0px rgba(23, 51, 80, 0.24);
  border-radius: 1.8667vw;
  background: #fff;
  top: 26.4083vh;
  padding: 2.8289vh 10.1333vw;
  text-align: center;
  .contact-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 3.9604vh;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      display: block;
      width: 11.2vw;
      height: 11.2vw;
    }
    .label {
      font-size: 2.1333vw;
      color: #666;
      margin: 0.9901vh 0 1.4144vh 0;
    }
    .line {
      background: rgba($color: #ccc, $alpha: 0.2);
      height: 1px;
      width: 100%;
    }
    .value {
      margin-top: 1.4144vh;
      font-size: 2.6667vw;
      color: #333333;
    }
  }
}
</style>